import {
  PageTitle,
  PageTitleProps,
} from '@supplement-bacon/react-toolkit/components'
import { Empty, Space } from 'antd'

interface Props {
  /** Section title, kept so the page keeps its section rhythm. */
  title: string
  /** One line explaining why there is nothing to chart here. */
  reason: string
  level?: PageTitleProps['level']
}

/**
 * Section placeholder for an analytics block a venue can never fill, e.g. a
 * venue whose bookings are taken by phone. Same shape as the "Not enough data
 * available." branch of the chart sections, minus the product/date toolbar:
 * there is nothing left to filter.
 */
const AnalyticsUnavailable = ({ title, reason, level = 5 }: Props) => (
  <Space orientation="vertical" className="w-full" size={16}>
    <PageTitle level={level} title={title} style={{ margin: 0 }} />
    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={reason} />
  </Space>
)

type AnalyticsUnavailableType = { Unavailable: typeof AnalyticsUnavailable }

export { AnalyticsUnavailable, type AnalyticsUnavailableType }
